// 2026-07-01 - FormuLearning - 관리자: 오퍼레이션 정의 목록 (이슈 #32)
// 파일 위치: frontend/src/features/admin/OperationCatalogList.tsx

import { useEffect, useState } from 'react'
import { listOperationCatalog } from '../../api/admin'
import type { OperationCatalogItem } from '../../types/admin'
import { opLabel } from '../../types/admin'

export default function OperationCatalogList() {
  const [rows, setRows] = useState<OperationCatalogItem[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    listOperationCatalog().then(setRows).catch(() => {}).finally(() => setLoading(false))
  }, [])

  if (loading) return <p className="text-sm text-text-secondary">Loading…</p>

  return (
    <div className="overflow-x-auto rounded-lg border" style={{ borderColor: 'var(--border-divider)' }}>
      <table className="w-full text-left text-sm">
        <thead className="text-xs text-text-secondary" style={{ backgroundColor: 'var(--color-bg-panel)' }}>
          <tr>
            <th className="px-3 py-2 font-medium">Operation</th>
            <th className="px-3 py-2 font-medium">Code</th>
            <th className="px-3 py-2 font-medium">Step</th>
            <th className="px-3 py-2 font-medium">Button</th>
            <th className="px-3 py-2 font-medium">Ext. API</th>
            <th className="px-3 py-2 font-medium">Substeps</th>
            <th className="px-3 py-2 font-medium">Source</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.code} className="border-t" style={{ borderColor: 'var(--border-divider)' }}>
              <td className="px-3 py-2 text-text-body">{opLabel(r.code)}</td>
              <td className="px-3 py-2 font-mono text-xs text-text-secondary">{r.code}</td>
              <td className="px-3 py-2 text-text-secondary">{r.step ?? '—'}</td>
              <td className="px-3 py-2 text-text-secondary">{r.button ?? '—'}</td>
              <td className="px-3 py-2">
                {r.triggers_external_api
                  ? <span style={{ color: 'var(--color-accent-teal)' }}>●</span>
                  : <span className="text-text-secondary">—</span>}
              </td>
              <td className="px-3 py-2 text-[11px] text-text-secondary max-w-[280px] truncate" title={(r.substeps ?? []).join(', ')}>
                {r.substeps && r.substeps.length > 0 ? r.substeps.join(', ') : '—'}
              </td>
              <td className="px-3 py-2 text-text-secondary">{r.source}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
